import Meta from 'src/components/meta/Meta';

const RentToBuyDefaultMeta = () => <Meta
  image="https://assets.brickx.com/images/rent-to-buy-share-image.jpg"
  imageAlt="Purchase your First Home sooner with BrickX Smart Renter"
/>;

export default RentToBuyDefaultMeta;
